import LocaleProvider from './locale-provider';
export default LocaleProvider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/locale-provider/index.js
// module id = 647
// module chunks = 2